import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const ConfirmModal = ({
  title,
  message,
  isShown,
  isPerformingAction,
  onConfirm,
  onCancel,
  confirmTitle,
  cancelTitle,
  error
}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title={ title }
    btnConfirmTitle={ confirmTitle ?? 'Ok' }
    btnConfirmClass={ `btn-danger ${ isPerformingAction ? 'loading' : '' }` }
    btnCancelTitle={ cancelTitle ?? 'Cancel' }
    onConfirm={ onConfirm }
    onCancel={ onCancel }
  >
    <span>
      { message }
    </span>
    {
      error
      && <div className="toast toast-error">
        { error }
      </div>
    }
  </ModalWrapper>
);

ConfirmModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isShown: PropTypes.bool,
  isPerformingAction: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  error: PropTypes.string
};

ConfirmModal.defaultProps = {
  title: null,
  message: null,
  isShown: false,
  isPerformingAction: false,
  confirmTitle: 'Ok',
  cancelTitle: 'Cancel',
  error: null
};

export default ConfirmModal;
